import { useQuery } from '@tanstack/react-query';
import { api, podatki } from '../api/odjemalec';
import { glave, obNapaki } from './zeton';

/** Ključ poizvedb za umetno inteligenco v skrbništvu (povezava, modeli, poraba, klici, instance). */
export const KLJUC_AI = ['skrbnik', 'ai'];

/** Ključ poizvedb za asistenta v skrbništvu (zahteve, ki jih ne zna, zmožnosti). */
export const KLJUC_ASISTENT_SKRBNIK = ['skrbnik', 'asistent'] as const;

/** Klic skrbniškega API-ja; potekla skrbniška seja (403) zahteva kodo znova. */
export async function klic<T>(k: () => Promise<T>): Promise<T> {
  try {
    return await k();
  } catch (e) {
    obNapaki(e);
    throw e;
  }
}

/** Skrbništvo: število zahtev v stanju NOVO (oznaka na zavihku), osveženo vsaki 2 minuti. */
export function useNoveZahteveAsistenta() {
  return useQuery({
    queryKey: [...KLJUC_ASISTENT_SKRBNIK, 'stevilo'],
    queryFn: ({ signal }) =>
      klic(() => podatki(api.GET('/api/skrbnik/asistent/manjkajoce/stevilo', { signal, headers: glave() }))),
    refetchInterval: 120_000,
  });
}
